<template>
  <form-field-select
    :disabled="disabled || !hasPhoneIntegration"
    :label="label"
    :value="value"
    @change="handleInput"
    :validation-errors="validationErrors"
    :help-text="
      !hasPhoneIntegration
        ? 'You must have a smrtPhone or CallRail integration to enable this.'
        : helpText
    "
  >
    <option
      v-for="(number, index) in phoneNumbers"
      :key="index"
      :value="number.id"
      :disabled="number.id !== null && number.flagged_for_termination_at"
    >
      {{ number.label }}: {{ $utils.formatNumber(number.number) }}
      <span v-if="number.id !== null && number.flagged_for_termination_at"
        >(for termination)</span
      >
    </option>
  </form-field-select>
</template>

<script>
import FormField from "./FormField";
import { FormFieldMixin } from "./FormField.mixin";

export default {
  name: "FormFieldSelectIntegrationPhoneNumber",
  components: { FormField },
  mixins: [FormFieldMixin],
  props: {
    value: {},
    placeholder: {
      type: String,
    },
    label: {
      type: String,
      default: "From Number",
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
    helpText: {
      type: String,
    },
    size: {
      type: String,
      default: "is-small",
    },
    hasEmptyOption: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasPhoneIntegration() {
      return this.$store.getters.hasPhoneIntegration;
    },
    phoneNumbers() {
      let allNumbers = this.$store.getters.integrationPhoneNumbers;

      allNumbers = allNumbers.filter((number) => {
        if (!number.port_active_at) return false;

        const active = new Date(number.port_active_at);
        const now = new Date();

        return now > active;
      });

      if (this.hasEmptyOption) {
        return [{ id: null, label: "Select a number" }, ...allNumbers];
      }

      return allNumbers;
    },
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.emitGlobalFieldChangeEvent();
    },
  },
};
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
